import React from 'react';
import ReactDOM from 'react-dom';
import {compose} from 'redux';

import AppStateHOC from '../lib/app-state-hoc.jsx';
import GUI from '../containers/gui.jsx';
import HashParserHOC from '../lib/hash-parser-hoc.jsx';

import styles from './index.css';

const onClickLogo = () => {
    window.location = 'https://scratch.mit.edu';
};

const WrappedGui = compose(
    AppStateHOC,
    HashParserHOC
)(GUI);

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);

GUI.setAppElement(appTarget);

ReactDOM.render(
    <WrappedGui
        canEditTitle
        isScratchDesktop={false}
        onClickLogo={onClickLogo}
    />,
    appTarget
);
